/**
 * Card primitive — design.md § Components: Cards.
 *
 * Variants: default (white bg-card, line border, card shadow), warm (bg-warm bg, line border, no shadow).
 * Uses rounded-lg (16px per design.md).
 */
import type { HTMLAttributes, ReactNode } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export type CardVariant = 'default' | 'warm';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  children: ReactNode;
}

const variantClasses: Record<CardVariant, string> = {
  default: 'bg-card border-line shadow-card',
  warm: 'bg-bg-warm border-line',
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
  function Card(
    {
      variant = 'default',
      className,
      children,
      ...props
    },
    ref,
  ) {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-lg border p-6',
          'transition-base',
          variantClasses[variant],
          className,
        )}
        {...props}
      >
        {children}
      </div>
    );
  },
);
